import ProtectedComponent from './protected-component.js';
import { isFeatureEnabled } from '../utils/feature-flags.js';
import {
  renderTinyPartyPanda,
  renderPartyPanda,
  renderPartyPandaMegaphone,
  renderDiscoCapybara,
  renderSafetyArmadillo,
  renderTacoUFO,
  renderMissingMole,
  renderSocietyOtter,
  renderGossipGoose
} from '../utils/mascots.js';

const MASCOTS = [
  { name: 'Tiny Party Panda', render: renderTinyPartyPanda },
  { name: 'Party Panda', render: renderPartyPanda },
  { name: 'Party Panda Megaphone', render: renderPartyPandaMegaphone },
  { name: 'Disco Capybara', render: renderDiscoCapybara },
  { name: 'Safety Armadillo', render: renderSafetyArmadillo },
  { name: 'Taco UFO', render: renderTacoUFO },
  { name: 'Missing Mole', render: renderMissingMole },
  { name: 'Society Otter', render: renderSocietyOtter },
  { name: 'Gossip Goose', render: renderGossipGoose }
];

class MascotParadePage extends ProtectedComponent {
  constructor() {
    super();
    this.handleFeatureFlagsLoaded = this.onFeatureFlagsLoaded.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
    this.renderContent();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('feature-flags-loaded', this.handleFeatureFlagsLoaded);
  }

  onFeatureFlagsLoaded() {
    this.renderContent();
  }

  load() {
    this.renderContent();
  }

  clear() {
    this.innerHTML = '';
  }

  renderContent() {
    if (!this.isAuthenticated()) {
      return;
    }

    if (!isFeatureEnabled('mascot_parade')) {
      if (window.router) {
        window.router.navigate('/');
      }
      return;
    }

    this.innerHTML = `
      <div class="mascot-parade-page" data-testid="mascot-parade-page">
        <header class="mascot-parade-header">
          <h1>🎪 Mascot Parade</h1>
          <p>Every friend of Fun Old Times, lined up and ready to party!</p>
        </header>
        <div class="mascot-parade-grid">
          ${MASCOTS.map((m) => `
            <div class="mascot-parade-card">
              <div class="mascot-parade-art">${m.render()}</div>
              <p class="mascot-parade-name">${m.name}</p>
            </div>
          `).join('')}
        </div>
      </div>
    `;
  }
}

customElements.define('mascot-parade-page', MascotParadePage);
